var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailymatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3178",
    "data-name": "Group 3178",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.323,
    height: 20.447,
    viewBox: "0 0 21.323 20.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "encounter-icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 13.337,
    height: 18.069,
    rx: 2,
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 0, 2.773)",
    fill: "#ea0f08"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    transform: "translate(7.988 0) rotate(1)",
    fill: "#ea0f08",
    stroke: "#ffe7e6",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.337,
    height: 18.069,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 12.837,
    height: 17.569,
    rx: 1.75,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailymatch);
export default __webpack_public_path__ + "static/media/dailymatch.632c10e73c9bafecbf44343e25437295.svg";
export { ForwardRef as ReactComponent };